import { GlobalSearchButton } from '../GlobalSearch/GlobalSearchButton';
import './GlobalNavbarActions.scss';
import searchIcon from "../../assets/Icons/search_icon.svg";
import partEntryIcon from "../../assets/Icons/part_entries_icon.svg";
import batchesIcon from "../../assets/Icons/batches_icon.svg";
import unitsConvertsIcon from "../../assets/Icons/units_converts_icon.svg";
import consumibleExpandibleIcon from "../../assets/Icons/consumible_expandible_icon.svg";
import physicalInventoryIcon from "../../assets/Icons/physical_inventory_icon.svg";
import iconViewMore from "../../assets/Icons/view_more_icon.svg";
import fileIcon from "../../assets/Icons/file_icon.svg";
import transactionIcon from "../../assets/Icons/transaction_icon.svg";
import { useEffect, useState } from 'react';
import { Notifications } from '../Notifications/Notifications';
import { ProfileMenu } from '../Profile-menu/ProfileMenu';
import { getAcronym } from '../../services/authService';

export const GlobalNavbarActions = ({screenActions}) => {

    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [showNotificationsMenu, setShowNotificationsMenu] = useState(false);
    const acronym = getAcronym();
    

    const visualizeProfileMenu = () => {
        setShowProfileMenu(true);
    };

    const hiddeProfileMenu = () => {
        setShowProfileMenu(false);
    };

    const visualizeNotificationsMenu = () => {
        setShowNotificationsMenu(true);
    };

    const hiddeNotificationsMenu = () => {
        setShowNotificationsMenu(false);
    };
    return (
        <section className="globalnavbaractions-component">
            {
                screenActions
            }
            <GlobalSearchButton searchIcon={searchIcon} partEntryIcon={partEntryIcon} batchesIcon={batchesIcon} unitsConvertsIcon={unitsConvertsIcon} consumibleExpandibleIcon={consumibleExpandibleIcon} physicalInventoryIcon={physicalInventoryIcon} iconViewMore={iconViewMore} fileIcon={fileIcon} transactionIcon={transactionIcon}>
                <div className="searchbutton navbar-action" >
                    <i className="icon-search"></i>
                </div>
            </GlobalSearchButton>
            {/* <div className="navbar-action">
                <i className="icon-help"></i>
            </div>
            <div className="navbar-action">
                <i className="icon-screen"></i>
            </div> */}
            <div
                onClick={() => setShowNotificationsMenu(prev => !prev)}
                className="navbar-action"
            >
                <i className="icon-notification"></i>
            </div>

            {/* profile */}
            <span
                className="navbar-menu-profile desktop bg-black-mid txt-white navbar-action"
                onMouseEnter={visualizeProfileMenu}
                onClick={() => setShowProfileMenu(prev => !prev)}

            >
                {acronym}
            </span>

            <span
                className="navbar-menu-profile mobiletablet bg-black-mid txt-white navbar-action"
                onClick={() => setShowProfileMenu(prev => !prev)}
            >
                {acronym}
            </span>


            <Notifications
                viewNotificatons={showNotificationsMenu}
                hiddeMenuFunction={hiddeNotificationsMenu}
            />
            <ProfileMenu
                menuVisible={showProfileMenu}
                hiddeMenuFunction={hiddeProfileMenu}
            />
        </section>
    )
}
